import apiCountryActions from 'services/api-country-actions';
import { Country } from 'types/country';
import { AppThunk } from '..';
import { getCountriesEnd, getCountriesStart, setData } from './countries-slice';

/**
 * getCountries()
 *
 * Gets all of the active countries
 *
 * @returns void
 */

export const getCountries = (): AppThunk => async dispatch => {
  try {
    dispatch(getCountriesStart());

    const data: Country[] | null = await apiCountryActions.getCountries();

    if (!data) {
      dispatch(getCountriesEnd());
      return;
    }

    const countries = data.map(country => country);

    dispatch(setData(countries));
  } catch (Ex) {
    console.error(Ex);
    dispatch(getCountriesEnd());
  }
};
